import {
  PAUSE_VIDEO_MAIN,
  RESUME_VIDEO_MAIN,
  VIDEO_PLAYBACK_START,
  VIDEO_PLAYBACK_STOP
} from './../actions/actions_video'

const initState = {
  video_paused: false,
  video_playing: false,
}

export default (state = initState, action) => {
  switch (action.type) {
    case PAUSE_VIDEO_MAIN:
      return { ...state, video_paused: true }
    case RESUME_VIDEO_MAIN:
      return { ...state, video_paused: false }
    case VIDEO_PLAYBACK_START:
      return { ...state, video_playing: true }
    case VIDEO_PLAYBACK_STOP:
      return { ...state, video_playing: false }
    default:
      return state
  }
}